import { createTelemetryEvent } from "../../telemetry/Telemetry";
import { telemetryChannelName } from "../../util/constants";
import { Heading, Message, Wrapper } from "./BigError.elements";
import Bugs from "./bugs.svg?react";
import { StyledButton } from "./Error.elements";

export function BigError({
  message,
  onReload = () => location.reload(),
}: {
  message: string;
  onReload?: () => void;
}): React.ReactElement {
  const reload = () => {
    createTelemetryEvent({
      feature: "error",
      action: "try again",
      action_meta: message,
    }).fire(telemetryChannelName);
    onReload();
  };

  return (
    <Wrapper>
      <Bugs style={{ width: "50%", margin: "auto", height: "auto" }} />
      <Heading>Oh no!</Heading>
      <p>Something went wrong.</p>
      <div>
        <StyledButton aria-label="Try Again" onClick={reload}>
          Try Again
        </StyledButton>
      </div>
      <Message>{message}</Message>
    </Wrapper>
  );
}
